import ProductEntryPage from './ProductEntryPage.container';

export default ProductEntryPage;